const convertToUTC = (value) => {
  try {
    const myDate = new Date(value).toLocaleDateString("en-US");
    return myDate;
  } catch (err) {
    console.error(`Error to convert UTC ${err}`);
  }
};

export default convertToUTC;
